import { NotFound } from '@/components/NotFound'
import { UpgradeGuard } from '@/components/UpgradeGuard'
import { ROUTER_BASE_NAME } from '@/configs/env'
import { lazy } from 'react'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'

const SPRING_FEST_2024 = lazy(() =>
  import(/* webpackChunkName: "spring-fest-2024" */ '@/features/spring-fest-2024'),
)
const CET4_2021 = lazy(() => import(/* webpackChunkName: "cet4-2021" */ '@/features/cet4-2021'))
const TERM_BEGINS_2022 = lazy(() =>
  import(/* webpackChunkName: "term-begins-2022" */ '@/features/term-begins-2022'),
)
const TeamUpRecite = lazy(() =>
  import(/* webpackChunkName: "team-up-recite" */ '@/features/team-up-recite'),
)
const TeamUpReciteS2 = lazy(() =>
  import(/* webpackChunkName: "team-up-recite-s2" */ '@/features/team-up-recite-s2'),
)
const TeamUpReciteS3 = lazy(() =>
  import(/* webpackChunkName: "team-up-recite-s3" */ '@/features/team-up-recite-s3'),
)
const TeamUpReciteS4 = lazy(() =>
  import(/* webpackChunkName: "team-up-recite-s4" */ '@/features/team-up-recite-s4'),
)

const TeamUpReciteS5 = lazy(() =>
  import(/* webpackChunkName: "team-up-recite-s5" */ '@/features/team-up-recite-s5'),
)

const TeamUpReciteS6 = lazy(() =>
  import(/* webpackChunkName: "team-up-recite-s5" */ '@/features/team-up-recite-s6'),
)

const BeforeExam = lazy(() =>
  import(/* webpackChunkName: "before-exam" */ '@/features/before-exam'),
)

const DailyQna = lazy(() => import(/* webpackChunkName: "daily-qna" */ '@/features/daily-qna'))

const GlobalPortal = lazy(() =>
  import(/* webpackChunkName: "global-portal" */ './features/_portal'),
)

const SchoolSeason2023 = lazy(() =>
  import(/* webpackChunkName: "school-season-2023" */ '@/features/school-season-2023'),
)

const SchoolSeason2023s4 = lazy(() =>
  import(/* webpackChunkName: "school-season-2023" */ '@/features/school-season-2023s4'),
)

const GlobalDemos = lazy(() => import(/* webpackChunkName: "global-demos" */ '@/features/_demos'))

const TurtDemos = lazy(() =>
  import(/* webpackChunkName: "turt-demos" */ '@/components/team-up-recite-templated/_demos'),
)

const OpenInstall = lazy(() =>
  import(/* webpackChunkName: "open-install" */ '@/features/openInstall'),
)

const WordMachineReferral = lazy(() =>
  import(/* webpackChunkName: "open-install" */ '@/features/wordMachine-Referral'),
)
const WordMachineJap = lazy(() =>
  import(/* webpackChunkName: "open-install" */ '@/features/wordMachineJap'),
)

const Report = lazy(() => import(/* webpackChunkName: "report" */ '@/features/report/ReportPage'))

// 单词竞赛
const CompEnter = lazy(() => import(/* webpackChunkName: "comp-Enter" */ '@/comp/entry'))
const CompDetail = lazy(() => import(/* webpackChunkName: "comp-Detail" */ '@/comp/detail'))

export function RouteConfig() {
  return (
    <Router basename={ROUTER_BASE_NAME}>
      <Routes>
        <Route path="cet4-2021/*" element={<CET4_2021 />} />
        <Route path="term-begins-2022/*" element={<TERM_BEGINS_2022 />} />
        <Route path="team-up-recite/*" element={<TeamUpRecite />} />
        <Route
          path="team-up-recite/s2/*"
          element={
            <UpgradeGuard>
              <TeamUpReciteS2 />
            </UpgradeGuard>
          }
        />
        <Route
          path="team-up-recite/s3/*"
          element={
            <UpgradeGuard>
              <TeamUpReciteS3 />
            </UpgradeGuard>
          }
        />
        <Route
          path="team-up-recite/s4/*"
          element={
            <UpgradeGuard>
              <TeamUpReciteS4 />
            </UpgradeGuard>
          }
        />
        <Route
          path="team-up-recite/s5/*"
          element={
            <UpgradeGuard>
              <TeamUpReciteS5 />
            </UpgradeGuard>
          }
        />
        <Route
          path="team-up-recite/s6/*"
          element={
            <UpgradeGuard>
              <TeamUpReciteS6 />
            </UpgradeGuard>
          }
        />
        <Route
          path="before-exam/*"
          element={
            <UpgradeGuard>
              <BeforeExam />
            </UpgradeGuard>
          }
        />
        <Route
          path="daily-qna/*"
          element={
            <UpgradeGuard>
              <DailyQna />
            </UpgradeGuard>
          }
        />
        <Route
          path="school-season-2023/*"
          element={
            <UpgradeGuard>
              <SchoolSeason2023 />
            </UpgradeGuard>
          }
        />
        <Route path="school-season-2023s4/*" element={<SchoolSeason2023s4 />} />
        <Route path="_portal/*" element={<GlobalPortal />} />
        <Route path="_demos/*" element={<GlobalDemos />} />
        <Route path="_demos/turt/*" element={<TurtDemos />} />
        <Route path="open-install" element={<OpenInstall></OpenInstall>}></Route>
        <Route path="spring-fest-2024/*" element={<SPRING_FEST_2024 />} />
        <Route path="wordMachine-referral/*" element={<WordMachineReferral />} />
        <Route path="wordMachineJap/*" element={<WordMachineJap />} />
        <Route path="report" element={<Report />} />
        <Route path="comp/entry" element={<CompEnter />} />
        <Route path="comp/detail" element={<CompDetail />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  )
}
